import { useState, useLayoutEffect } from 'react'

import { InputCheck } from '../../../../../../../../Forms/InputCheck'
import { useCouponRules } from '../../../couponRulesContext'
import { Product } from '../Product'

import { Container, Content } from './style'


export function Group({ group }) {
    const { 
        productsSelectedsToLink, 
        setProductsSelectedsToLink 
    } = useCouponRules()
    const [checked, setChecked] = useState(false)
    const listProductsCodes = group.products.map(product => product.idProduct)

    function handleClickCheckboxGroup() {  
        setChecked(state => !state)

        if(!checked)
            checkAllProductsFromGroup()
        else
            uncheckAllProductsFromGroup()
    }

    function checkAllProductsFromGroup() {
        setProductsSelectedsToLink(list => [...list, ...listProductsCodes])
    }

    function uncheckAllProductsFromGroup() {
        setProductsSelectedsToLink(oldList =>  oldList.filter(product => !listProductsCodes.includes(product)))
    }

    useLayoutEffect(() => {
        if(!!productsSelectedsToLink.length) {
            setChecked(listProductsCodes.every(product => productsSelectedsToLink.includes(product)))
        
            return
        }

        setChecked(false)

        //eslint-disable-next-line
    }, [productsSelectedsToLink])


    return (
        <Container>
            <Content>
                <InputCheck 
                    checked={checked}
                    handleClick={handleClickCheckboxGroup}
                />
                <p>{group.name}</p>
            </Content>

            {
                group.products.map(product => (
                    <Product 
                        key={product.idProduct}
                        product={product}
                    />
                ))
            }
        </Container>
    )
}